import ActionTypePlan from "../ActionTypePlan";

export default class ActualizarPlan extends ActionTypePlan {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        /* nuevoEstado.flag.sensorDeAccionActualizar = !(estado.flag.sensorDeAccionActualizar); */
        return nuevoEstado;
    }
}
